import { createApp } from 'vue'
import App from './App.vue'

// Router
import router from './router'

// Store
import store from './store'

// FontAwesome
import { FontAwesomeIcon } from '@/plugins/fontawesome'

// Plugins
import './plugins'

// Global styles
import './styles/main.css'

// Create app instance
const app = createApp(App)

// Register FontAwesome component globally
app.component('font-awesome-icon', FontAwesomeIcon)

// Install plugins
app.use(router)
app.use(store)

// Initialize auth state
store.dispatch('auth/initializeAuth')

// The API client fires this on a 401 (see plugins/axios.js): the stored token is
// dead. Clear auth - or the app keeps booting as "authenticated" from localStorage
// and the route guard bounces every navigation - and go to /login once, even if
// several requests fail together.
let handlingExpiredSession = false
window.addEventListener('auth:expired', async () => {
  if (handlingExpiredSession) return
  handlingExpiredSession = true
  try {
    store.commit('auth/CLEAR_AUTH_DATA')
    if (router.currentRoute.value.name !== 'Login') {
      await router.push({ name: 'Login', query: { redirect: router.currentRoute.value.fullPath } })
    }
  } finally {
    handlingExpiredSession = false
  }
})

// Note: Sidebar menu items are now initialized in AppLayout.vue
// based on user authentication and roles

// Development logging
if (import.meta.env.VITE_APP_DEBUG === 'true') {
  console.log('🚀 Vue 3 App Starting...')
  console.log('App Name:', import.meta.env.VITE_APP_NAME)
  console.log('API URL:', import.meta.env.VITE_API_URL)
  console.log('Environment:', import.meta.env.VITE_APP_ENV)
}

// Mount app
app.mount('#app')
